import React from 'react';
import { withTranslation } from 'react-i18next';
import { Modal, PaperTitle, Button, ButtonsContainer } from 'virtues-bootstrap';
import PropTypes from 'prop-types';

import s from './styles.module.scss';

const TokenExpried = ({ handleHide, show, t }) => (
  <Modal show={show ? 1 : 0}>
    <PaperTitle size="md" withBorder>
      {t('tokenExpired.title')}
      <div className={s.paperSubTitle}>
        <span>{t('tokenExpired.description')}</span>
      </div>
      <ButtonsContainer wrapped>
        <Button onClick={handleHide}>OK</Button>
      </ButtonsContainer>
    </PaperTitle>
  </Modal>
);

TokenExpried.propTypes = {
  show: PropTypes.bool.isRequired,
  handleHide: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(TokenExpried);
